"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _Player2 = _interopRequireDefault(require("../models/Player"));
var _htmlMediaEvents = _interopRequireDefault(require("../constants/htmlMediaEvents"));
var _hlsEvents = _interopRequireDefault(require("./constants/hlsEvents"));
var _getElapsedPercent = _interopRequireDefault(require("../utils/getElapsedPercent"));
var _playerName = _interopRequireDefault(require("../constants/playerName"));
var _mediaFormats = _interopRequireDefault(require("../constants/mediaFormats"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var hlsErrorTypes = {
  networkError: 'networkError'
};
function onError(callback, format) {
  return function (event) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var details = data.details,
      fatal = data.fatal,
      response = data.response,
      type = data.type,
      url = data.url;
    var error = new Error("".concat(_playerName["default"].HlsJsPlayer, " error"));
    var isNetworkError = type === hlsErrorTypes.networkError;
    // format errors are also considered network errors by players, so we'll use this flag to
    // allow logging of potential formatting compatibility issues
    var isFormatError = format !== _mediaFormats["default"].hls;
    error.errorData = {
      event: event,
      details: details,
      fatal: fatal,
      response: response,
      type: type,
      url: url,
      isNetworkError: isNetworkError,
      isFormatError: isFormatError
    };
    return callback(error);
  };
}
var HlsJsPlayer = exports["default"] = /*#__PURE__*/function (_Player) {
  (0, _inherits2["default"])(HlsJsPlayer, _Player);
  function HlsJsPlayer(hlsjs, audioElement, containerId) {
    var _this;
    (0, _classCallCheck2["default"])(this, HlsJsPlayer);
    _this = _callSuper(this, HlsJsPlayer, [_playerName["default"].HlsJsPlayer]);
    _this.hlsjs = hlsjs;
    _this.audioElement = audioElement;
    _this.containerId = containerId;
    _this.isLiveSeek = false;
    return _this;
  }
  (0, _createClass2["default"])(HlsJsPlayer, [{
    key: "init",
    value: function init() {
      return this.hlsjs.init();
    }
  }, {
    key: "inheritConfigs",
    value: function inheritConfigs(configs) {
      Object.assign(this, configs);
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      if (_hlsEvents["default"][event]) {
        this.hlsjs.addEventListener(event, callback);
      } else {
        var callbackToUse = callback;
        if (event === _htmlMediaEvents["default"].error) {
          callbackToUse = onError(callback, this.format);
          this.cachedErrorCallback = callbackToUse;
        }
        this.audioElement.addEventListener(event, callbackToUse);
      }
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      if (_hlsEvents["default"][event]) {
        this.hlsjs.removeEventListener(event, callback);
      } else {
        var callbackToUse = callback;
        if (event === _htmlMediaEvents["default"].error) {
          callbackToUse = this.cachedErrorCallback;
          delete this.cachedErrorCallback;
        }
        this.audioElement.removeEventListener(event, callbackToUse);
      }
    }
  }, {
    key: "load",
    value: function load(url, format, position) {
      var _this2 = this;
      this.format = format;
      return new Promise( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(resolve, reject) {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this2.hlsjs.addEventListener(_hlsEvents["default"].ERROR, onError(reject, format), true);
                _context.prev = 1;
                _context.next = 4;
                return _this2.hlsjs.attachMedia(_this2.audioElement);
              case 4:
                _context.next = 6;
                return _this2.hlsjs.loadSource(url, position, _this2.isLiveSeek);
              case 6:
                resolve();
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                // just in case the event isn't hlsEvents.ERROR, for whatever reason
                onError(reject, format)(_context.t0);
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 9]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "play",
    value: function play() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var errorCallback = onError(reject, _this3.format);
        _this3.audioElement.addEventListener(_htmlMediaEvents["default"].error, errorCallback, {
          once: true
        });
        _this3.audioElement.addEventListener(_htmlMediaEvents["default"].playing, resolve, {
          once: true
        });
        _this3.audioElement.play();
      });
    }
  }, {
    key: "pause",
    value: function pause() {
      this.audioElement.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.audioElement.pause();
    }
  }, {
    key: "unload",
    value: function () {
      var _unload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.hlsjs.off();
              this.hlsjs.detachMedia();
              _context2.next = 4;
              return this.hlsjs.destroy();
            case 4:
              _context2.next = 6;
              return this.hlsjs.init();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function unload() {
        return _unload.apply(this, arguments);
      }
      return unload;
    }()
  }, {
    key: "destroy",
    value: function () {
      var _destroy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var container;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.hlsjs.off();
              _context3.next = 3;
              return this.hlsjs.destroy();
            case 3:
              container = document.getElementById(this.containerId);
              if (container) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return");
            case 6:
              container.parentElement.removeChild(container);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function destroy() {
        return _destroy.apply(this, arguments);
      }
      return destroy;
    }()
  }, {
    key: "canChangePlaybackRate",
    value: function canChangePlaybackRate() {
      var playbackRate = this.audioElement.playbackRate;
      return !!playbackRate && playbackRate > 0;
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/playbackRate
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.audioElement.playbackRate;
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/playbackRate
  }, {
    key: "changePlaybackRate",
    value: function changePlaybackRate(rate) {
      this.audioElement.playbackRate = rate;
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      if ((0, _isNumber["default"])(volume)) {
        this.audioElement.volume = volume / 100;
      }
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.audioElement.volume;
    }
  }, {
    key: "toggleMute",
    value: function toggleMute() {
      this.audioElement.muted = !this.audioElement.muted;
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      this.audioElement.setAttribute('title', title);
    }
  }, {
    key: "getTimes",
    value: function getTimes() {
      var audio = this.audioElement;
      var duration = Math.floor(audio.duration || 0);
      var elapsedSeconds = Math.floor(audio.currentTime || 0);
      var elapsedPercent = (0, _getElapsedPercent["default"])(elapsedSeconds, duration);
      return {
        duration: duration,
        elapsedSeconds: elapsedSeconds,
        elapsedPercent: elapsedPercent
      };
    }
  }]);
  return HlsJsPlayer;
}(_Player2["default"]);
//# sourceMappingURL=HlsJsPlayer.js.map